<template>
  <div class="findlawtip">
    <div class="tiptit">找律师小贴士</div>
    <div class="zdmblist">
      <div
        v-for="(item, index) in list"
        :key="index"
        :title="item.title"
        :name="item.index"
        class="zdmbitem"
        :style="{height:index == activeNames?heightnum:'20px'}"
      >
        <div class="zdhead between" @click="autoheight(index)">
          <div class="zdbt">{{ item.title }}</div>
          <div class="svgjt">
            <svg-icon icon-class="jt_right" 

            :class="{flip90:index != activeNames,flip_90:index == activeNames}"
             />
          </div>
        </div>
        <div class="zdnr" ref='colled'>{{ item.cont }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: 0,
      list: [
        {
          title: "服务方都是专业法律人士吗？",
          cont: `在“好律师”平台（以下简称“本平台”）注册
的服务方包括：律师、仲裁员、法学教授、法学
讲师、公证员及其他法律财务税务专业人士,以及
律师事务所、会计师事务所及其他专业咨询服务
机构。服务方注册时均已由本平台进行了真实身
份的审核,您可安心交易。（注：除与其他身份并
举以外,为简化起见,本平台所称“律师”是指前述
服务方的合称。）`,
        },
        {
          title: "如何全面了解律师信息？",
          cont: `在“好律师”平台（以下简称“本平台”）注册
的服务方包括：律师、仲裁员、法学教授、法学
讲师、公证员及其他法律财务税务专业人士,以及。）`,
        },
        {
          title: "可以与律师进行在线沟通吗？",
          cont: `在“好律师”平台（以下简称“本平台”）注册
的服务方包括：律师、仲裁员、法学教授、法学
讲师、公证员及其他法律财务税务专业人士,以及
律师事务所）`,
        },
        {
          title: "服务方标注“特别保障”字样有...",
          cont: `在“好律师”平台（以下简称“本平台”）注册
的服务方包括：律师、仲裁员、法学教授、法学
讲师、公证员及其他法律财务税务专业人士,以及
律师事务所、会计师事务所及其他专业咨询服务
机构。服务方注册时均已由本平台进行了真实身
份的审核,您可安心交易。（注：除与其他身份并
举以外,为简化起见,本平台所称“律师”是指前述
讲师、公证员及其他法律财务税务专业人士,以及
律师事务所、会计师事务所及其他专业咨询服务
机构。服务方注册时均已由本平台进行了真实身
份的审核,您可安心交易。（注：除与其他身份并
举以外,为简化起见,本平台所称“律师”是指前述
服务方的合称。）`,
        },
        {
          title: "服务方都是专业法律人士吗？",
          cont: `在“好律师”平台（以下简称“本平台”）注册
的服务方包括：律师、仲裁员、法学教授、法学
讲师、公证员及其他法律财务税务专业人士,以及
律师事务所、会计师事务所及其他专业咨询服务
机构。服务方注册时均已由本平台进行了真实身
份的审核,您可安心交易。（注：除与其他身份并
举以外,为简化起见,本平台所称“律师”是指前述
服务方的合称。）`,
        },
      ],
      heightnum:''
    };
  },
  mounted(){
      this.autoheight(this.activeNames)
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    
    autoheight(index) {
        this.heightnum = this.$refs.colled[index].clientHeight + 30 +'px'
        this.activeNames = index
    },
  },
};
</script>

<style lang="scss" scope>
.findlawtip {
  width: 100%;
  padding: 20px;
  .tiptit {
    font-size: 18px;
    color: #333333;
    padding: 10px 0 20px;
    border-bottom: 1px solid #eee;
  }
  .zdmblist {
    .zdmbitem {
      margin-top: 28px;
      overflow: hidden;
      transition: all .3s;
      .zdhead {
          cursor: pointer;
        .zdbt {
          font-size: 14px;
          color: #333333;
        }
        .svgjt {
          color: #ccc;
          font-size: 12px;
          padding-right: 5px;
        }
      }
      .zdnr {
        margin-top: 10px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>